export enum ProviderCustomActionType {
	REGISTER,
	LOGIN,
	YOLO,
}
